import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { UserService } from "../../../../core/services/user.service";
import { AuthBllService } from "../../../../features/auth/auth-bll.service";
import { HomeBllService } from "../../../../features/home/home-bll.service";
import { LeftMenu, MenuItem, User } from "../../../models/base-response.model";
import { EventDetailsResponseModel } from "../../../../features/home/home.model";

@Component({
  selector: "app-left-side-nav",
  imports: [RouterModule, CommonModule],
  templateUrl: "./left-side-nav.component.html",
  styleUrl: "./left-side-nav.component.scss",
})
export class LeftSideNavComponent implements OnInit {
  /**
   * The list of navigation items shown in the side menu.
   * Each item contains:
   * - label: the text to display
   * - icon: the Material icon name
   * - route: the router path to navigate to
   */
  menuItems: MenuItem[] = [
    {
      label: "Home",
      icon: "assets/images/home_icon.png",
      route: "home"
    },
    {
      label: "Buy Ticket",
      route: "reg/select-ticket",
      imgLabel: "assets/images/buy-ticket-menu.png", // <-- image for label
    },
    {
      label: "Digital Catalog",
      route: 'catalogue/pavilion-list',
      imgLabel: "assets/images/digital-catalog-menu.png", // <-- image for label
    },       
    {
      label: "FAQs",
      icon: "assets/images/faq_icon.png",
      route: "https://kisan.app/web/support_en.html",
      external: true,
    },
    {
      label: "Terms & Privacy",
      icon: "assets/images/t&c_icon.png",
      route: "https://pune.kisan.in/terms-conditions#digital",
      external: true,
    },
    {
      label: "Logout",
      icon: "assets/images/logout_icon.png",
      route: "",
      requiresAuth: true,
    },
  ];

  /**
   * Controls whether the side nav should be displayed.
   * It is hidden on certain pages based on the route title.
   */

  isVisible: boolean = true;

  /**
   * Indicates if the current page is the home page.
   */
  isHomePage: boolean = false;
  /**
   * Stores the current page’s title, if you need to display it or log it.
   */
  pageName: string = "";

  /**
   * Holds user information like name and profile image URL.
   */
  userInfo: { name: any; image: any } = { name: "", image: "" };

  /**
   * Indicates if the user is authenticated.
   */
  isAuthenticated: boolean = false;

  user: User | null = null;

  leftMenu: LeftMenu | null = null;

  /**
   * @param route Provides access to the current route’s data (including `title`).
   */
  constructor(
    private authService: AuthBllService,
    private router: Router,
    private userService: UserService,
    private homeBll: HomeBllService,
  ) { }

  /**
   * Lifecycle hook that runs after component construction and input binding.
   * Subscribes to the route’s title observable and toggles `isVisible` based on
   * which page is active.
   */
  ngOnInit(): void {
    /**
     * Subscribe to authentication status changes to update the menu accordingly.
     */
    this.authService.isAuthenticated$.subscribe((isAuthenticated) => {
      console.log("isAuthenticated:", isAuthenticated);
      this.isAuthenticated = isAuthenticated;
    });

    /**
     * Check if the current page is the home page.
     */
    this.isHomePage = this.homeBll.isHomePage();

    this.userService.leftMenu$.subscribe((leftMenu) => {
       this.leftMenu = leftMenu;

        /**
     * If the user is authenticated, fetch their event status and subscribe to user data changes.
     */
    if (this.isAuthenticated) {
      this.userService.user$.subscribe((user) => {
        this.user = user;
        if(this.user?.hasUnassignedTickets && this.leftMenu?.allow_to_register === 1){
          this.addFillTicketsMenuItem();
        }
        if(this.user?.hasAssignedTickets && this.leftMenu?.event_status !== 'over'){
          this.addMyTicketsMenuItem();
        }
      });
    }

    });
  }

  /**
   * Logs out the current user by invoking the authentication service's logout method
   * and clears the user data from the user service.
   *
   * @remarks
   * This method should be called when the user chooses to log out of the application.
   *
   * @public
   */
  logout() {
    this.authService.logout();
    this.userService.clearUser();
  }

  cleanNumber(num: any | null) {
    return num?.replace(/^\+91/, "");
  }
  /**
   * Handles the "Edit Profile" button click.
   */
  onEditProfileClick() {
    console.log("Edit profile clicked");
    const currentUrl = this.router.url; // <-- capture current page
    this.router.navigate(["reg/edit-basic-profile"], {
      state: { returnUrl: currentUrl }, // <-- pass it dynamically
    });
  }

  /**
   *
   * @param item The menu item that was clicked.
   * @returns
   */
  onMenuClick(item: any) {
    if (item.label === "Logout") {
      this.logout();
      return;
    }

    if (item.external) {
      window.open(item.route, "_blank"); // open external in new tab
    } else if (item.route) {
      this.router.navigate([item.route]); // Angular routing
    }
  }

  /**
   * Adds the "Fill Tickets Form" menu item if it doesn't already exist.
   */
  addFillTicketsMenuItem() {
    const exists = this.menuItems.some(
      (item) => item.label === "Fill Ticket Forms"
    );

    if (!exists) {
      const insertAt = 3; // After "My Tickets" index

      this.menuItems.splice(insertAt, 0, {
        label: "Fill Ticket Forms",
        icon: "assets/images/assign-form.png",
        route: "reg/assign-ticket",
        requiresAuth: true,
      });
    }
  }

  addMyTicketsMenuItem() {
    const exists = this.menuItems.some(
      (item) => item.label === "My Tickets"
    );

    if (!exists) {
      const insertAt = 1;
      
      this.menuItems.splice(insertAt, 0, {
        label: "My Tickets",
        icon: "assets/images/myTicket_icon.png",
        route: "reg/my-tickets",
        requiresAuth: true,
      });
    }
  }

  isLowOpacityItem(item: MenuItem): boolean {
    return (
      item.label === 'FAQs' ||
      item.label === 'Terms & Privacy' ||
      item.label === 'Logout'
    );
  }

}
